<template>
  <div class="step-section">
    <h2>Step One: Which dates are you ordering bloods for?</h2>
    <p>
    	Select your dates from the date-picker, and they'll be automatically added below.
    </p>
    <p>
    	<input type="date" @change="addDate">
    </p>
    <div v-if="dates.length > 0">
    	<h4 class="date-selection-title">Currently ordering for:</h4>
    	<div v-for="date,index in dates" :key="index">
    		<div class="date-selection">
    			<div><LongDate :date="date" /></div>
    			<a @click="deleteDate(date)">x</a>
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>

import LongDate from './LongDate.vue'

export default {
  name: 'StepOne',
  components: {LongDate},
  data() {
    return {
  		dates:[]
  	}
  },
  methods: {
  	addDate(event) {
  		var newDate = event.target.value
      if (this.dates.length >= 5) {
        alert('We recommend ordering no more than 5 days worth of bloods in advance.')
        return
      }
  		if (!this.dates.includes(newDate)) {
  			this.dates.push(newDate)
  		}
  		event.target.value = ''
      this.emitDates()
  	},
  	deleteDate(date) {
  		this.dates = this.dates.filter(function(item) {
  			return item !== date
  		})
      this.emitDates()
  	},
    emitDates() {
      this.$emit('update:dates', this.dates)
    }
  }
}
</script>

<style>

	.date-selection-title {
		text-align: left;
	}

	.date-selection {
		width: 200px;
		padding: 2px 4px 2px 4px;
		background-color: rgb(220, 220, 220);
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.date-selection a:hover {
		color: red;
		cursor: pointer;
	}
</style>
